export default "__VITE_ASSET__Ctnwq8ZV__"